import EnhancedTab from 'lib/designSystem/TabSimulation';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import Portfolios from './Portfolios';
import Signers from './Signers';

const Contracts = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const tabs = [
    {
      id: 1,
      label: 'Portafolios',
      component: <Portfolios />,
      path: 'portfolios',
    },
    {
      id: 2,
      label: 'Firmantes',
      component: <Signers />,
      path: 'signers',
    },
  ];

  const handleNavigation = (index: number) => {
    navigate(`/companies/${id}/contracts/${tabs[index].path}`);
  };

  return (
    <EnhancedTab
      tabType="secondary"
      startValue={0}
      tabs={tabs}
      onTabChange={handleNavigation}
    />
  );
};

export default Contracts;
